import { ChakraBox as Box, ChakraAccordion as Accordion } from "@airhelp/react-ui-components";
import ApraInfo from "../ApraInfo";
import Copyright from "../Copyright";
import SocialIcons from "../SocialIcons";
import Menu from "../Menu";
import MenuAccordionItem from "./MenuAccordionItem";
import type { MenusProps } from "../Footer.d";

const MobileFooter = ({ menus }: { menus: MenusProps }) => (
  <>
    <Box px={8} pt={16}>
      <ApraInfo />
      <Menu menu={menus.imprint} />
      <SocialIcons />
    </Box>
    <Accordion allowToggle mt={10} data-testid="mobile-footer-section" borderY="1px" borderColor="greyscale.400">
      <MenuAccordionItem label="menu_our_company" menu={menus.company} />
      <MenuAccordionItem label="menu_know_your_rights" menu={menus.knowYourRights} />
      <MenuAccordionItem label="menu_our_products" menu={menus.products} />
      <MenuAccordionItem label="menu_support" menu={menus.support} />
      <MenuAccordionItem label="menu_other" menu={menus.legal} />
    </Accordion>
    <Box px={8} py={9}>
      <Copyright />
    </Box>
  </>
);

export default MobileFooter;
